import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { PlanLevel } from '@ninety/platform/models/billing/plan-level';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

@Component({
  standalone: true,
  imports: [TerraIconModule, NinetyCMModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <!--    -->
    <ninety-cm-tiered-page>
      <div headline>Unlock Powerful Insights for Your Business</div>
      <div description>
        Upgrade your plan for access to Insights. Track and analyze all your activity and tools in Ninety to empower
        data-driven decisions that fuel growth and improve performance.
      </div>
      <button ninety-cm-button (click)="onCTAClick()">
        <terra-icon icon="lightning" variant="fill" />
        Explore {{ pricingTierEnum.Accelerate }} Plan
      </button>
      <a href="https://help.ninety.io/en_US/insights/introduction-to-insights" rel="external" target="_blank">
        Learn more about Insights
      </a>
    </ninety-cm-tiered-page>`,
})
export class InsightsTieredPageComponent {
  private readonly store = inject(Store);

  pricingTierEnum = PlanLevel;

  constructor() {
    this.store.dispatch(FilterBarActions.hide());
  }

  onCTAClick() {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
